/* eslint-disable dot-notation */
import moment from 'moment';
import { isQRIban } from 'utils';
import { azpWithdrawalDateFormatUtc, dateTimeStandardFormat, formatDate } from 'utils/datetime';
import { roundToNearestTenth } from 'utils/formatting';

type SendModelType = {
    data: any,
    isAzp?: boolean,
    amountAccount?: number,
    amountDeposit?: number,
    deferralPhaseDuration?: number,
    plannedEndDate?: string,
    withdrawalAmount?: string | number,
}

type PaymentInstructionRequestProps = {
    iban: string;
    esr?: string;
    firstName: string;
    lastName: string;
    bankName: string;
    zipCity: string;
    city: string;
}

export const sendModel = ({
    data,
    isAzp,
    amountAccount,
    amountDeposit,
    deferralPhaseDuration,
    plannedEndDate,
    withdrawalAmount,
}: SendModelType) => {
    const withdrawalRequest = {
        withdrawalAmount: isAzp ? roundToNearestTenth(withdrawalAmount) : roundToNearestTenth(data?.amount),
        periodicity: parseInt(data?.frequency, 10),
        startDate: moment(data?.startDate, 'MM/YYYY').format(moment.defaultFormatUtc),
        ...(isAzp ? {
            investmentAmount: parseFloat(data?.amount).toFixed(2),
            amountAccount,
            amountDeposit,
            deferralPhaseDuration,
            plannedEndDate,
        } : {}),
    };

    if (data?.duration && data?.withdrawalsStartDate) {
        withdrawalRequest['duration'] = parseInt(data?.duration, 10);
        withdrawalRequest['compoundDuration'] = Math.round((deferralPhaseDuration ?? 0) / 12) + +data?.duration;
        withdrawalRequest.startDate = data?.withdrawalsStartDate;

        if (isAzp && data?.withdrawalsStartDate) {
            withdrawalRequest.startDate = moment(data?.withdrawalsStartDate).format(azpWithdrawalDateFormatUtc);
        }
    }

    if (data?.targetPortfolio) {
        withdrawalRequest['targetPortfolio'] = parseInt(data?.targetPortfolio, 10);
    }

    const paymentInstructionRequest: PaymentInstructionRequestProps = {
        iban: data?.iban,
        firstName: data?.firstName,
        lastName: data?.lastName,
        bankName: data?.bankName,
        zipCity: data?.zipCode,
        city: data?.city,
    };

    if (data?.esr && isQRIban(data?.iban)) {
        paymentInstructionRequest.esr = data.esr;
    }

    const payload = {
        withdrawalRequest,
        paymentInstructionRequest,
    };

    return payload;
};

export const sendWithdrawalPlanModel = (data, isAzp) => {
    const payload = {
        InvestmentAmount: parseFloat(data?.amount).toFixed(2),
        StartOfWithdrawal: (isAzp && data?.withdrawalsStartDate) ? moment(data?.withdrawalsStartDate).format(azpWithdrawalDateFormatUtc) : formatDate(data?.withdrawalsStartDate, dateTimeStandardFormat),
        Periodicity: parseInt(data?.frequency, 10),
        Duration: parseInt(data?.duration, 10),
    };

    return payload;
};
